import { render } from "./IndividualInformation.vue?vue&type=template&id=4f5e590b&scoped=true"
import script from "./IndividualInformation.vue?vue&type=script&lang=js"
export * from "./IndividualInformation.vue?vue&type=script&lang=js"

import "./IndividualInformation.vue?vue&type=style&index=0&id=4f5e590b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5e590b"]])

export default __exports__